import {toast} from 'react-toastify';

export function NotificationError(msg, title = '', time = 5000, onClick = null) {
  if (msg) {
    toast.error(msg, {
      position: 'top-right',
      autoClose: time,
      hideProgressBar: false,
      closeOnClick: onClick,
      pauseOnHover: true,
      draggable: true,
    });
  }
}

export function NotificationSuccess(msg, title = '', time = 5000, onClick = null) {
  if (msg) {
    toast.success(msg, {
      position: 'top-right',
      autoClose: time,
      hideProgressBar: false,
      closeOnClick: onClick,
      pauseOnHover: true,
      draggable: true,
    });
  }
}

export function NotificationInfo(msg, title = '', time = 5000, onClick = null) {
  if (msg) {
    toast.info(msg, {
      position: 'top-right',
      autoClose: time,
      hideProgressBar: false,
      closeOnClick: onClick,
      pauseOnHover: true,
      draggable: true,
    });
  }
}
